import { call, put, takeEvery } from 'redux-saga/effects';
import { INewDealerRequestFull, newDealerActionCreators, NewDealerActionKeys, RejectNewDealerRequest } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';

function* rejectNewDealerRequestSaga(action: RejectNewDealerRequest) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = yield call(
    api.rejectNewDealerRequest,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setRequest(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchRejectNewDealerRequest() {
  yield takeEvery(NewDealerActionKeys.REJECT_NEW_DEALER_REQUEST, rejectNewDealerRequestSaga);
}
